/* SILKIN : retire la ligne "+10 000 clientes satisfaites" de l'encadre de confiance */
(function(){
  function slkCleanTrust(){
    document.querySelectorAll('.slk-trust__row').forEach(function(row){
      if(/clientes satisfaites/i.test(row.textContent)){ row.remove(); }
    });
  }
  /* SILKIN : offre du moment -40 % (bandeaux accueil + page produit) */
  function slkOffre(){
    document.querySelectorAll('[id$="__rich_text_37xkmJ"], [id$="__rich_text_7fXcta"]').forEach(function(sec){
      var w=document.createTreeWalker(sec, NodeFilter.SHOW_TEXT), n;
      while((n=w.nextNode())){ if(/[−–-]\s?20\s?%/.test(n.nodeValue)){ n.nodeValue=n.nodeValue.replace(/[−–-]\s?20\s?%/g,'−40%'); } }
    });
  }
  function run(){ slkCleanTrust(); slkOffre(); }
  run();
  document.addEventListener('DOMContentLoaded', run);
})();
